// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2ceafc41] #password::-moz-placeholder{--text-opacity:1;color:#333;color:rgba(51,51,51,var(--text-opacity))}[data-v-2ceafc41] #password:-ms-input-placeholder{--text-opacity:1;color:#333;color:rgba(51,51,51,var(--text-opacity))}[data-v-2ceafc41] #password::placeholder{--text-opacity:1;color:#333;color:rgba(51,51,51,var(--text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
